import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { useDynamicFormsUtils, useTableFiltersActions } from "@ryde/redux";
import { Log, TTimeHHmm, ValueType } from "@ryde/shared";

import { TimeFilterField } from "./parts";

interface IFilterTime {
  customFieldId: number;
  value: ValueType;
}

export const FilterTime = ({
  customFieldId,
  value,
}: IFilterTime): ReactElement => {
  const { t } = useTranslation();
  const { getGridControlLabelById } = useDynamicFormsUtils();
  const { setValuesToFilter, handleRemoveFilter } = useTableFiltersActions();

  const onApply = (time: TTimeHHmm | undefined): void => {
    setValuesToFilter(customFieldId, time ? [time] : []);
  };

  const onRemove = (): void => {
    if (customFieldId) {
      handleRemoveFilter(customFieldId);
    } else {
      Log.warnAndToast(t("errors.cantRemoveFilterInvalidFieldId"));
    }
  };

  return (
    <TimeFilterField
      fieldId={`grid-filter-time-${customFieldId}`}
      label={customFieldId ? getGridControlLabelById(customFieldId) : ""}
      value={value}
      onApply={onApply}
      onRemove={onRemove}
    />
  );
};
